export default __webpack_public_path__ + "scripts/resource/d7f3b85fa0cfb91eaf40c1507a017be5.svg";